import { DAY_IN_SECONDS } from './constants';

export const minusDaysToCurrentDate = (date: Date, days: number): Date =>
    new Date(date.getTime() - days * DAY_IN_SECONDS);
